import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    const bannerHidden = localStorage.getItem("bannerHidden");

    // If it doesn't, this means the user has not closed the banner
    // so make it appear. (We remove the class rather than add it
    // to prevent jitter).

    bannerHidden !== "true" && this.element.classList.remove("hidden");
  }

  handleAgree() {
    this.element.classList.add("hidden");
    localStorage.setItem("bannerHidden", true);
  }

  handleDisagree() {
    this.element.classList.add("hidden");
  }
}
